<!-------------------------------------
|   Author: Payal Tripathy             |
|   Date: 21-04-2023                   |
|                                      |
|   Last Updated By: Ajay              |
|   Date: 13-05-2023                   |
--------------------------------------->

<div class="conf-configurator-layout">
    <div class="conf-configurator-wrapper">

        <!--##############################################################
                                MAIN LOB SECTION
            ############################################################## -->
        <div class="conf-head-wrapper">
            <div class="nav-header-section">
                <app-conf-nav-header></app-conf-nav-header>
            </div>
            <div class="step-bar">
                <app-conf-progress-step-bar></app-conf-progress-step-bar>
            </div>
        </div>


        <!--##############################################################
                            HEADER SECTION (LOB SECTION TITLE)
            ############################################################## -->

        <div class="main-section-wrapper">
            <div class="conf-outer-main" [ngClass]="lob != '' ? lob : ''">
                <div class="main-section">
                    <div class="conf-routeBody">
                        <router-outlet (activate)="onActivate($event)"></router-outlet>
                    </div>
                </div>
                <app-conf-footer></app-conf-footer>
            </div>

        </div>

    </div>

</div>
